import { render, staticRenderFns } from "./FuneralModal.vue?vue&type=template&id=4d1b62fe"
import script from "./FuneralModal.vue?vue&type=script&lang=js"
export * from "./FuneralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports